<template>
    <div>
		<vs-dialog 
			:width="alert.width" 
			v-model="alert.show" 
			blur 
			not-close
			prevent-close>
			<template #header v-if="alert.title !== null">
				<h4 class="not-margin">
					{{ $t(alert.title) }}
				</h4>
			</template>

			<div v-if="Array.isArray(alert.message)">
				<mu-col class="text-center" v-for="(msg, index) of alert.message" :key="index">
					<span class="">
						{{ $t(msg) }}
					</span>
				</mu-col>
			</div>
			
			<div v-else>
				<span class="text-center">
					<mu-col class="text-center">
						<span class="">
							{{ $t(alert.message) }}
						</span>
					</mu-col>	
				</span>
			</div>

			<br>

			<template #footer>
				
				<div class="row">
					<div class="col text-center">
						<mu-button color="red" @click="alert.leave" class="mt-1 mb-1">
							<span>
								{{ alert.cancel_label == null ? `${$tc('button_action.close')}` : alert.cancel_label }}
							</span>
						</mu-button>
                        <mu-button color="blue800" @click="alert.accept" class="mt-1 mb-1">
							<span>
								{{ alert.confirm_label == null ? `${$t('button_action.continue')}` : alert.confirm_label }}
							</span>
						</mu-button>
					</div>
				</div>
			</template>
		</vs-dialog>
    </div>
</template>
    
<script>

	import _GlobalHelper from '@/store/helpers/global'
	
	import { mapActions, mapGetters, mapMutations } from 'vuex'
    
    export default {
        name: 'alert-options',
        data() {
            return {

            }
        },
        computed: {
        	...mapGetters({
				alert: _GlobalHelper.getters.alert_options
			}),
		},
		methods: {
			...mapMutations({
				setAlertSimple: _GlobalHelper.mutations.setAlertSimple
			})
		}

    }
</script>

<style>

</style>